'use client';

import Footer from '../global/partials/Footer';
import HeaderV2 from '../global/partials/HeaderV2';
import HeroSection from '../pageComponents/pricing/HeroSection';
import PricingCardsGrid from '../pageComponents/global/PricingCardsGrid';
import ForWhoSection from '../pageComponents/pricing/ForWhoSection';
import GettingStartedSection from '../pageComponents/pricing/GettingStartedSection';
import RewardsSection from '../pageComponents/pricing/RewardsSection';
import ProfitSliderSection from '../pageComponents/global/sections/ProfitSliderSection';
import TestimonialsSection from '../pageComponents/global/sections/TestimonialsSection';
import { PagePricingSchema } from '@/sanity/pages/PagePricingTemplate';
import ScrollingBanner from '../pageComponents/global/ScrollingBanner';
import TestimonialsSectionV2 from '../pageComponents/global/sections/TestimonialsSectionV2';
import {
  PricingHeroBlock,
  PricingTiersBlock,
  PricingComparisonBlock,
  PricingPlatformsBlock,
} from '../pageComponents/pricingSectionV2';
import NewPricingSection from '../pageComponents/newPricing/NewPricingSection';

export default function PagePricingJSX({ data }: { data: PagePricingSchema }) {
  return (
    <main className="flex flex-col items-center">
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType={'main'}
          language={data.settings?.language}
        />
      )}

      <HeroSection data={data} />

      {data?.pricingSectionV3 ? (
        <NewPricingSection
          sectionV3={data.pricingSectionV3}
          section={data.pricingSectionV2}
          language={data.settings?.language}
          hideHero
        />
      ) : data?.pricingSectionV2 ? (
        <section className="relative w-full">
          <div className="mx-auto w-[min(170.625rem,calc(100%-4rem))] flex flex-col gap-[6rem]">
            {/* <PricingHeroBlock
              data={data.pricingSectionV2}
              language={data.settings?.language}
            /> */}
            <PricingTiersBlock
              data={data.pricingSectionV2}
              language={data.settings?.language}
              discount={data?.pricingV2Discount}
            />
            {data.pricingSectionV2.comparison &&
            data.pricingSectionV2.specsCatalog?.length ? (
              <PricingComparisonBlock
                data={data.pricingSectionV2}
                language={data.settings?.language}
                discount={data?.pricingV2Discount}
              />
            ) : null}
            {data.pricingSectionV2.platformsFooter && (
              <PricingPlatformsBlock
                data={data.pricingSectionV2.platformsFooter}
                language={data.settings?.language}
              />
            )}
          </div>
        </section>
      ) : data?.pricingCardRefs?.length ? (
        <section className="relative w-full">
          <div className="mx-auto w-[min(170.625rem,calc(100%-4rem))]">
            <PricingCardsGrid
              cards={data.pricingCardRefs}
              assetPrimaryLabel={data.pricingCardsPrimaryTabLabel}
              assetSecondaryLabel={data.pricingCardsSecondaryTabLabel}
              defaultAssetTab={data.pricingCardsActiveTab}
              challengeAccountsLabel={data.pricingCardsChallengeAccountsLabel}
              instantFundingLabel={data.pricingCardsInstantFundingLabel}
              challengeLabel={data.pricingCardsChallengeLabel}
              fundedLabel={data.pricingCardsFundedLabel}
              language={data.settings?.language}
              discountSettings={data.discountSettings}
            />
          </div>
        </section>
      ) : null}
      <ProfitSliderSection className="py-[10rem]" data={data} />
      <ForWhoSection data={data} />

      <TestimonialsSectionV2
        className="w-[98%]"
        language={data.settings?.language}
        data={{
          testimonialsChip: data.tradersStoryChip,
          testimonialsTitle: data.tradersStoryTitle,
          testimonialsSummary: data.tradersStorySummary,
          testimonialsBackgroundImage: data.tradersStoryBackgroundImage,
          testimonialsCards:
            data.tradersStoryCardsRef ?? data.tradersStoryCards,
          scrollingWords: data.scrollingWords,
        }}
      />

      <GettingStartedSection data={data} />
      <RewardsSection data={data} />

      <ScrollingBanner
        className="bg-[#f4f5f5] border-y-0"
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
      />

      {data?.settings?.footer && <Footer data={data.settings?.footer} finalCta={data} language={data?.settings?.language} />}
    </main>
  );
}
